module.exports = __webpack_public_path__ + "img/Group 140.da8224a1.svg";